/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
  PostApiV1TutoraiDocumentsDocumentidImportPathParams,
  PostApiV1TutoraiDocumentsDocumentidImport400,
  PostApiV1TutoraiDocumentsDocumentidImport401,
  PostApiV1TutoraiDocumentsDocumentidImport404,
  PostApiV1TutoraiDocumentsDocumentidImport500,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsDocumentidImport.ts";

function getPostApiV1TutoraiDocumentsDocumentidImportUrl(
  documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/tutorai/documents/${documentId}/import` as const,
  };
  return res;
}

/**
 * @description Realiza chunking, gera embeddings e indexa no TutorAI. **(Requer Authorization para autenticação)**
 * @summary Importar documento (chunking + embedding) (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:documentId/import}
 */
export async function postApiV1TutoraiDocumentsDocumentidImport(
  documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsDocumentidImport400
      | PostApiV1TutoraiDocumentsDocumentidImport401
      | PostApiV1TutoraiDocumentsDocumentidImport404
      | PostApiV1TutoraiDocumentsDocumentidImport500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1TutoraiDocumentsDocumentidImportUrl(
      documentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
